import { ICoordinatesModel } from "../interfaces";

export class CoordinatesModel implements ICoordinatesModel {
  longitude: number;
  latitude: number;
  plaka?: number;
  stationId?: number;
  elevation?: number;
  radarPath?: string;
  takeoffWindDirection?: Array<string>;

  constructor(data: ICoordinatesModel) {
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.plaka = data.plaka;
    this.elevation = data.elevation;
    this.stationId = data.stationId;
    this.radarPath = data.radarPath;
    this.takeoffWindDirection = data.takeoffWindDirection;
  }
}


